import "../../styles/all.css"
import "../../styles/theme.css"
import personone from "../../img/p1.png"
import persontwo from "../../img/p2.png"
import personthree from "../../img/p3.png"
import personfour from "../../img/p4.png"
import personfive from "../../img/p5.png"
import personsix from "../../img/p6.png"
import "./table.css"


function Table(){
    return(
        <>
        <div className="leads">
              <div className="table">
            <div className="start">
                <h4>Latest Leads</h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="end">
                <table className="table table-hover  rounded align-middle">
    <thead> 
      <tr>
        <th>Users</th>
              <th>Info</th>

        <th>Proposal</th>
        <th>Date</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <img src={personone} alt="" />
        </td>
        <td>
          <p>Archie Cantones</p>
          <p>ariceh.tones@gmail.com</p>
        </td>
        <td>Sent</td>
        <td>11/06/2023 10:53</td>
        <td>Compelted</td>
        <td>        <i className="fa-solid fa-ellipsis-vertical"></i>
</td>

      </tr>
     <tr>
        <td>
          <img src={persontwo} alt="" />
        </td>
        <td>
          <p>Holmes Cherryman</p>
          <p>cherryman @gmail.com</p>
        </td>
        <td>New</td>
        <td>11/06/2023 10:53</td>
        <td>In Progress</td>
        <td>        <i className="fa-solid fa-ellipsis-vertical"></i>
</td>

      </tr>
       <tr>
        <td>
          <img src={personthree} alt="" />
        </td>
        <td>
          <p>Malanie Hanvey</p>
          <p>malan-hanvey@gmail.com</p>
        </td>
        <td>Sent </td>
        <td>11/06/2023 10:53</td>
        <td>Compelted</td>
        <td>        <i className="fa-solid fa-ellipsis-vertical"></i>
</td>

      </tr>
      <tr>
        <td>
          <img src={personfour} alt="" />
        </td>
        <td>
          <p>Kenneth Hune</p>
          <p>nneth.une@gmail.com</p>
        </td>
        <td>Returnning</td>
        <td>11/06/2023 10:53</td>
        <td>Not Intersted</td>
        <td>        <i className="fa-solid fa-ellipsis-vertical"></i>
</td>

      </tr>
        <tr>
        <td>
          <img src={personfive} alt="" />
        </td>
        <td>
          <p>Kennth Hune </p>
          <p>nneth.une@gmail.com</p>
        </td>
        <td>Returnning</td>
        <td>11/06/2023 10:53</td>
        <td>Not Intersted</td>
        <td>        <i className="fa-solid fa-ellipsis-vertical"></i>
</td>

      </tr>
      
     
     
    </tbody>
  </table>
            </div>
        </div>
        </div>
        </>
    )
}
export default Table